module.exports = __webpack_public_path__ + "static/media/unsplash.d5bd1536.svg";